import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import numeral from 'numeral'

function TimeSelect({
  name,
  value = null,
  placeholder = '00:00',
  onChange,
  isTimeZoneSelect = false,
  customClass = '',
}) {
  function getOptions() {
    if (isTimeZoneSelect) {
      return I18n.t('time_zones')
    }
    const options = []

    for (let i = 0; i <= 24; i++) {
      options.push({ value: `${numeral(i).format('00')}:00`, label: `${numeral(i).format('00')}:00` })
    }

    return options
  }

  return (
    <Select
      className={`Select-outline ${customClass}`}
      options={getOptions()}
      placeholder={placeholder}
      searchable={false}
      clearable={false}
      value={value}
      onChange={(data) => onChange(name, data.value)}
    />
  )
}

TimeSelect.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  isTimeZoneSelect: PropTypes.bool,
  customClass: PropTypes.string,
}

export default TimeSelect
